module.exports = __webpack_public_path__ + "static/media/DqEveryChildNationTurkeyHero.0c3d52d6.jpg";